import React from 'react';
import PropTypes from 'prop-types';

const PermissionGuard = ({
    permissions,
    children,
    component: Component,
    fallback = null,
    requireAll = false,
    ...rest // Pass through other props to the component if provided
}) => {
    // Retrieve user permissions from localStorage, consistent with SideBar.js
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const userPermissions = userDetails?.roleDetails?.permissions || [];

    // Normalize permissions to an array
    const requiredPermissions = permissions ? (Array.isArray(permissions) ? permissions : [permissions]) : [];

    const hasPermission = () => {
        if (requiredPermissions.length === 0) return true;

        if (requireAll) {
            return requiredPermissions.every(p => userPermissions.includes(p));
        } else {
            return requiredPermissions.some(p => userPermissions.includes(p));
        }
    };

    const isAllowed = hasPermission();

    if (isAllowed) {
        if (Component) {
            return <Component {...rest} />;
        }
        return children;
    }

    return fallback;
};

PermissionGuard.propTypes = {
    permissions: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    children: PropTypes.node,
    component: PropTypes.elementType,
    fallback: PropTypes.node,
    requireAll: PropTypes.bool
};

export default PermissionGuard;
